import { ReferenceDataSetLinkSet, ReferenceDataSetSource } from './reference-data.types';

export const tables: ReferenceDataSetSource = {
  productCategory: [
    { code: 'UAE01', name: 'Assurance Extra' },
    { code: 'UBU01', name: 'Business' },
  ],

  policyStatusCode: [
    { code: 'IF', name: 'In Force' },
    { code: 'OOF', name: 'Out of Force' },
    { code: 'PIF', name: 'Pending in Force' },
    { code: 'QFA', name: 'Quote for Alteration' },
    { code: 'CPUP', name: 'Contractually Paid Up' },
    { code: 'IFWP', name: 'In Force under Waiver of Premium' },
  ],

  policyDiscount: [
    { code: 'LT3', name: '3% Lifetime Discount' },
    { code: 'LT5', name: '5% Lifetime Discount' },
    { code: 'LT10', name: '10% Lifetime Discount' },
    { code: 'LT15', name: '15% Lifetime Discount' },
  ],

  paymentFrequency: [
    { code: 'WEEK01', name: 'week' },
    { code: 'MONT01', name: 'month' },
    { code: 'FORT01', name: 'fortnight' },
    { code: 'HAYE01', name: 'half-year' },
    { code: 'YEAR01', name: 'year' },
  ],

  paymentFrequencyDesc: [
    { code: 'WEEK01', name: 'Weekly payment' },
    { code: 'FORT01', name: 'Fortnightly payment' },
    { code: 'MONT01', name: 'Monthly payment' },
    { code: 'HAYE01', name: 'Half-yearly payment' },
    { code: 'YEAR01', name: 'Yearly payment' },
  ],

  marketingCampaign: [
    { code: 'MCOLS01', name: 'OnePath Life Standard' },
    { code: 'MCFUN01', name: 'Funeral' },
    { code: 'MCANZ01', name: 'ANZ' },
    { code: 'MCSX01', name: 'Southern Cross' },
    { code: 'MCCHDI01', name: 'Chubb Direct' },
  ],

  gender: [
    { code: 'MALE', name: 'Male' },
    { code: 'FEMALE', name: 'Female' },
    { code: 'UNKN', name: 'Unknown' },
  ],

  smoker: [
    { code: 'SMOK', name: 'Yes' },
    { code: 'NSMK', name: 'No' },
    { code: 'ZUNK', name: 'Unknown' },
  ],

  coverageType: [
    { code: 'LIFE01', name: 'Life Cover' },
    { code: 'LIIN01', name: 'Life Income Cover' },
    { code: 'TRAU01', name: 'Trauma Cover' },
    { code: 'TPDT01', name: 'TPD on Trauma' },
    { code: 'CODI01', name: 'Complete Disablement' },
    { code: 'INCO01', name: 'Income Cover' },
    { code: 'LOEA01', name: 'Loss of Earnings' },
    { code: 'MORE01', name: 'Mortgage Repayment Cover' },
    { code: 'REDU01', name: 'Redundancy Cover' },
    { code: 'EXPE01', name: 'Expenses Cover' },
    { code: 'SPIN01', name: 'Specific Injury' },
    { code: 'PREM01', name: 'Premium Cover' },
    { code: 'TRCH01', name: 'Trauma Child' },
    { code: 'FUNE01', name: 'Funeral Cover' },
    { code: 'TBC', name: 'BUSINESS' },
  ],

  coverageCode: [
    { code: 'uLife', name: 'Life Cover' },
    { code: 'uLifeIncome', name: 'Life Income Cover' },
    { code: 'uTraumaA', name: 'Trauma - Accelerated' },
    { code: 'uTPDonTraumaA', name: 'TPD on Trauma Accelerated' },
    { code: 'uTraumaS', name: 'Trauma - Standalone' },
    { code: 'uTPDonTraumaS', name: 'TPD on Trauma Standalone' },
    { code: 'uCompDisA', name: 'Complete Disablement Accelerated' },
    { code: 'uCompDisS', name: 'Complete Disablement Standalone' },
    { code: 'uIncome', name: 'Income Cover' },
    { code: 'uMRepaymentCov', name: 'Mortgage Repayment Cover' },
    { code: 'uRedundancy', name: 'Redundancy Cover' },
    { code: 'uSpecificInjury', name: 'Specific Injury Cover' },
    { code: 'uPremium', name: 'Premium Cover' },
    { code: 'uTraumaChild', name: 'Child Trauma Cover' },
    { code: 'uTraumaA_MD', name: 'Moderate Trauma Accelerated' },
    { code: 'uTPDonTraumaA_MD', name: 'TPD on Moderate Trauma Accelerated' },
    { code: 'uTraumaS_MD', name: 'Moderate Trauma Standalone' },
    { code: 'uTPDonTraumaS_MD', name: 'TPD on Moderate Trauma Standalone' },
    { code: 'uLOE', name: 'Loss of Earnings Cover' },
    { code: 'AEBLife', name: 'AEB Business Life Cover' },
    { code: 'AEB', name: 'TraumaA	Business Trauma Accelerated Cover' },
    { code: 'AEB', name: 'TraumaS	Business Trauma Standalone Cover' },
    { code: 'AEBCompDisA', name: 'BusinessComplete Disablement Accelerated Cover' },
    { code: 'AEBMDisStandard', name: 'Monthly Disability Cover' },
    { code: 'AEBMDisStartUp', name: 'Start-up Monthly Disability Cover' },
    { code: 'AEBBusO/Heads', name: 'Monthly Disability Cover - Business Overheads' },
    { code: 'AEBFarmConsult', name: 'Monthly Disability Cover - Farm Consultancy ' },
    { code: 'AEBSpecInjury', name: 'Business Specfic Injury Cover' },
    { code: 'AEBPremCover', name: 'Business Premium Cover' },
    { code: 'AEBKPMonthSA1', name: 'KP Month Sum 1 ' },
    { code: 'AEBKPMonthSA2', name: 'KP Month Sum 2' },
    { code: 'AEBKPMonthSA3', name: 'KP Month Sum 3' },
    { code: 'AEBKPMonthSA4', name: 'KP Month Sum 4' },
    { code: 'AEBKPMonthSA5', name: 'KP Month Sum 5' },
    { code: 'AEBKPMonthSA6', name: 'KP Month Sum 6' },
    { code: 'AEBKPMonthSA7', name: 'KP Month Sum 7' },
    { code: 'AEBKPMonthSA8', name: 'KP Month Sum 8' },
    { code: 'AEBKPMonthSA9', name: 'KP Month Sum 9' },
    { code: 'AEBKPMonthSA10', name: 'KP Month Sum 10' },
    { code: 'AEBKPMonthSA11', name: 'KP Month Sum 11' },
    { code: 'AEBKPMonthSA12', name: 'KP Month Sum 12' },
    { code: 'mLife', name: 'Modular Life Cover' },
    { code: 'mtraumaS', name: 'Modular Trauma Standalone' },
    { code: 'mExpensesCov', name: 'Modular Expenses Cover' },
    { code: 'mPremCover', name: 'Modular Premium Cover' },
    { code: 'Funeral', name: 'Cover	Funeral Cover' },
  ],

  coverageDisplayOrder: [
    { code: '1', name: 'uLife' },
    { code: '2', name: 'uLifeIncome' },
    { code: '3', name: 'uTraumaA' },
    { code: '4', name: 'uTraumaS' },
    { code: '5', name: 'uCompDisA' },
    { code: '6', name: 'uCompDisS' },
    { code: '7', name: 'uMRepaymentCov' },
    { code: '8', name: 'uIncome' },
    { code: '9', name: 'uLOE' },
    { code: '10', name: 'uSpecificInjury' },
    { code: '11', name: 'uRedundancy' },
    { code: '12', name: 'uPremium' },
    { code: '13', name: 'uTraumaChild' },
  ],

  coverageStatusCode: [
    { code: 'IF', name: 'In Force' },
    { code: 'OOF', name: 'Out of Force' },
    { code: 'PIF', name: 'Pending in Force' },
    { code: 'QFA', name: 'Quote for Alteration' },
    { code: 'CPUP', name: 'Contractually Paid Up' },
    { code: 'IFWP', name: 'In Force under Waiver of Premium' },
  ],

  premiumReviewPeriod: [
    { code: 'YRT', name: '1 Year(s)' },
    { code: '5YR', name: '5 Year(s)' },
    { code: 'YR5P5', name: '5 Year(s) 5% Stepped' },
    { code: '10YR', name: '10 Year(s)' },
    { code: 'AGE65', name: 'To Age 65' },
    { code: 'AGE70', name: 'To Age 70' },
    { code: 'AGE75', name: 'To Age 75' },
    { code: 'AGE80', name: 'To Age 80' },
    { code: 'AGE100', name: 'To Age 100' },
  ],

  indexation: [
    { code: 'CPI', name: 'Yes' },
    { code: 'LEVEL', name: 'No' },
  ],

  waitPeriod: [
    { code: '4WEEKS', name: '4 Week Wait Period' },
    { code: '8WEEKS', name: '8 Week Wait Period' },
    { code: '13WEEKS', name: '13 Week Wait Period' },
    { code: '26WEEKS', name: '26 Week Wait Period' },
    { code: '52WEEKS', name: '52 Week Wait Period' },
    { code: '104WEEKS', name: '104 Week Wait Period' },
    { code: '6MONTHS', name: '6 Months' },
    { code: '8 Weeks', name: '8 Week Wait Period' },
    { code: '13 Weeks', name: '13 Week Wait Period' },
  ],

  coverTerm: [
    { code: 'AGE19', name: 'Age 19' },
    { code: 'AGE65', name: 'Age 65' },
    { code: 'AGE70', name: 'Age 70' },
    { code: 'AGE75', name: 'Age 75' },
  ],

  paymentTerm: [
    { code: '6MONTHS', name: '6 Months' },
    { code: '2YEAR', name: '2 Year' },
    { code: '5YEAR', name: '5 Year' },
    { code: '10YEAR', name: '10 Year' },
    { code: '15YEAR', name: '15 Year' },
    { code: '20YEAR', name: '20 Year' },
    { code: '25YEAR', name: '25 Year' },
    { code: '30YEAR', name: '30 Year' },
    { code: 'AGE65', name: 'Age 65' },
    { code: 'AGE70', name: 'Age 70' },
    { code: 'AGE75', name: 'Age 75' },
  ],

  coverageOptionName: [
    { code: 'GIO01', name: 'Guaranteed Insurability' },
    { code: 'HOPR01', name: 'Hold Pricing' },
    { code: 'LTRP01', name: 'LTR Discount Percentage' },
    { code: 'LTRC02', name: 'LTR Discount Code' },
    { code: 'TUGI01', name: 'Taken Up GIO' },
    { code: 'TUSE01', name: 'Taken Up Special Event' },
    { code: 'TARI01', name: 'Talisman Rider' },
    { code: 'LEDI01', name: 'Legacy Discount' },
    { code: 'LIRE01', name: 'Lifetime Reward' },
    { code: 'LIBU01', name: 'Life Buyback' },
    { code: 'TRBU01', name: 'Trauma Buyback' },
    { code: 'CAPL01', name: 'Cancer Plus' },
    { code: 'RIDT01', name: 'Rider Discount' },
    { code: 'CAFR01', name: 'Campaign Free' },
    { code: 'OCTR01', name: 'Optional Continous Trauma' },
    { code: 'OCDE01', name: 'Occupation Definition' },
    { code: 'WAPE01', name: 'Wait Period Extension' },
    { code: 'MEHR01', name: 'Mental Health Restriction' },
    { code: 'INCT01', name: 'Income Cover Type' },
    { code: 'DERE01', name: 'Dependant Leave Without Pay' },
    { code: 'EXOP01', name: 'Extra Option' },
    { code: 'INTU01', name: 'Income Take Up' },
    { code: 'REWP01', name: 'Reduced Wait Period' },
    { code: 'SOIC01', name: 'Sickness Only Income Cover' },
    { code: 'TPDI01', name: 'Talisman Premium - Disability' },
    { code: 'TPPC01', name: 'Talisman Premium - Premium Cover' },
    { code: 'TPTT01', name: 'Talisman Premium - TPD on Trauma' },
    { code: 'LOEE01', name: 'Loss of Earnings Extra' },
    { code: 'MODE01', name: 'Mortgage Deluxe' },
    { code: 'LOTY01', name: 'LOE Type' },
    { code: 'OCDE01', name: 'TPD' },
  ],

  occupationClass: [
    { code: 'OCC1', name: '1' },
    { code: 'OCC2', name: '2' },
    { code: 'OCC3', name: '3' },
    { code: 'OCC4', name: '4' },
    { code: 'OCC5', name: '5' },
    { code: 'OCC6', name: '6' },
    { code: 'INDC', name: 'IC' },
    { code: 'UNIN', name: 'Uninsurable' },
  ],

  occupationDefinition: [
    { code: 'Y', name: 'Own Occupation' },
    { code: 'N', name: 'Any Occupation' },
  ],

  incomeCoverType: [
    { code: 'Y', name: 'Agreed Value' },
    { code: 'N', name: 'Indemnity' },
  ],

  sicknessOnlyIncomeCover: [
    { code: 'STD', name: 'Agreed Value' },
    { code: 'SICK', name: 'Indemnity' },
  ],

  LOECoverType: [
    { code: 'STD', name: 'Loss of Earnings' },
    { code: 'ULTR', name: 'Loss of Earnings Ultra' },
  ],

  TPD: [
    { code: '', name: 'No' },
    { code: 'Y', name: 'Yes - Own Occupation' },
    { code: 'N', name: 'Yes - Any Occupation' },
  ],

  coverageComission: [
    { code: 'STCO01', name: 'Standard' },
    { code: 'ASEA01', name: 'As Earned' },
    { code: 'ANZ001', name: 'anz@work' },
  ],

  commissionRenewal: [
    { code: 'STCR01', name: 'Standard' },
    { code: '5R', name: '5% Renewal' },
    { code: '10R', name: '10% Renewal' },
    { code: '15R', name: '15% Renewal' },
    { code: '17R', name: '17% Renewal' },
    { code: '20R', name: '30% Renewal' },
    { code: '30R', name: '5% Renewal' },
    { code: '32.5R', name: '32.50% Renewal' },
    { code: '40R', name: '40% Renewal' },
    { code: '42.5R', name: '42.50% Renewal' },
    { code: '50R', name: '50% Renewal' },
  ],

  coveragePremiumDiscount: [
    { code: '4PD', name: '5% Policy Discount ' },
    { code: '5PD', name: '4% Policy Discount' },
    { code: '8PD', name: '8% Policy Discount' },
    { code: '14PD', name: '14% Policy Discount' },
    { code: '15PD', name: '15% Policy Discount' },
    { code: '16PD', name: '16% Policy Discount' },
    { code: '20PD', name: '20% Policy Discount' },
    { code: '24PD', name: '24% Policy Discount' },
    { code: '25PD', name: '25% Policy Discount' },
    { code: '30PD', name: '30% Policy Discount' },
    { code: '40PD', name: '40% Policy Discount' },
    { code: 'STPD01', name: 'Standard' },
  ],
};

export const links: ReferenceDataSetLinkSet = [
  { table: 'waitPeriod', code: '6MONTHS', coverageCode: 'uTPDonTraumaA' },
  { table: 'waitPeriod', code: '6MONTHS', coverageCode: 'uTPDonTraumaS' },
  { table: 'waitPeriod', code: '6MONTHS', coverageCode: 'uCompDisA' },
  { table: 'waitPeriod', code: '6MONTHS', coverageCode: 'uCompDisS' },

  { table: 'coverTerm', code: 'AGE65', coverageCode: 'uIncome' },
  { table: 'coverTerm', code: 'AGE70', coverageCode: 'uIncome' },
  { table: 'coverTerm', code: 'AGE65', coverageCode: 'uMRepaymentCov' },
  { table: 'coverTerm', code: 'AGE70', coverageCode: 'uMRepaymentCov' },
  { table: 'coverTerm', code: 'AGE19', coverageCode: 'uPremium' },
  { table: 'coverTerm', code: 'AGE65', coverageCode: 'uPremium' },
  { table: 'coverTerm', code: 'AGE70', coverageCode: 'uPremium' },
  { table: 'coverTerm', code: 'AGE75', coverageCode: 'uPremium' },
  { table: 'coverTerm', code: 'AGE65', coverageCode: 'uLOE' },
  { table: 'coverTerm', code: 'AGE70', coverageCode: 'uLOE' },
  { table: 'coverTerm', code: 'AGE70', coverageCode: 'uTraumaA' },
  { table: 'coverTerm', code: 'AGE75', coverageCode: 'uTraumaA' },
  { table: 'coverTerm', code: 'AGE70', coverageCode: 'uTraumaS' },
  { table: 'coverTerm', code: 'AGE75', coverageCode: 'uTraumaS' },
  { table: 'coverTerm', code: 'AGE65', coverageCode: 'uCompDisA' },
  { table: 'coverTerm', code: 'AGE70', coverageCode: 'uCompDisA' },
  { table: 'coverTerm', code: 'AGE65', coverageCode: 'uCompDisS' },
  { table: 'coverTerm', code: 'AGE70', coverageCode: 'uCompDisS' },

  { table: 'paymentTerm', code: '6MONTHS', coverageCode: 'uRedundancy' },
  { table: 'paymentTerm', code: '2YEAR', coverageCode: 'uIncome' },
  { table: 'paymentTerm', code: '5YEAR', coverageCode: 'uIncome' },
  { table: 'paymentTerm', code: 'AGE65', coverageCode: 'uIncome' },
  { table: 'paymentTerm', code: 'AGE70', coverageCode: 'uIncome' },
  { table: 'paymentTerm', code: '2YEAR', coverageCode: 'uLOE' },
  { table: 'paymentTerm', code: '5YEAR', coverageCode: 'uLOE' },
  { table: 'paymentTerm', code: 'AGE65', coverageCode: 'uLOE' },
  { table: 'paymentTerm', code: 'AGE70', coverageCode: 'uLOE' },
  { table: 'paymentTerm', code: '2YEAR', coverageCode: 'uMRepaymentCov' },
  { table: 'paymentTerm', code: '5YEAR', coverageCode: 'uMRepaymentCov' },
  { table: 'paymentTerm', code: 'AGE65', coverageCode: 'uMRepaymentCov' },
  { table: 'paymentTerm', code: 'AGE70', coverageCode: 'uMRepaymentCov' },
  { table: 'paymentTerm', code: 'AGE75', coverageCode: 'uTraumaA' },
  { table: 'paymentTerm', code: 'AGE70', coverageCode: 'uTraumaA' },
  { table: 'paymentTerm', code: 'AGE70', coverageCode: 'uTraumaS' },
  { table: 'paymentTerm', code: 'AGE75', coverageCode: 'uTraumaS' },
  { table: 'paymentTerm', code: 'AGE65', coverageCode: 'uTPDonTraumaA' },
  { table: 'paymentTerm', code: 'AGE65', coverageCode: 'uTPDonTraumaS' },
  { table: 'paymentTerm', code: 'AGE70', coverageCode: 'uCompDisA' },
  { table: 'paymentTerm', code: 'AGE75', coverageCode: 'uCompDisA' },
  { table: 'paymentTerm', code: 'AGE65', coverageCode: 'uCompDisS' },
  { table: 'paymentTerm', code: 'AGE70', coverageCode: 'uCompDisS' },
  { table: 'paymentTerm', code: '6MONTHS', coverageCode: 'uPremium' },
  { table: 'paymentTerm', code: '2YEAR', coverageCode: 'uPremium' },
  { table: 'paymentTerm', code: '5YEAR', coverageCode: 'uPremium' },
  { table: 'paymentTerm', code: '10YEAR', coverageCode: 'uPremium' },
  { table: 'paymentTerm', code: '15YEAR', coverageCode: 'uPremium' },
  { table: 'paymentTerm', code: '20YEAR', coverageCode: 'uPremium' },
  { table: 'paymentTerm', code: '25YEAR', coverageCode: 'uPremium' },
  { table: 'paymentTerm', code: '30YEAR', coverageCode: 'uPremium' },
  { table: 'paymentTerm', code: 'AGE65', coverageCode: 'uPremium' },
  { table: 'paymentTerm', code: 'AGE70', coverageCode: 'uPremium' },
];
